module.exports = __webpack_public_path__ + "img/logo.5ca7c915.png";